import { Badge, Box, Button, Image, Stack, Text, VStack } from '@chakra-ui/react';
import React from 'react';
import { Icon, Img } from '../../../../content/Content';
import './Annoucement.css'

const AnnouncementsRight = () => {

    const AnnouncementsData = [
        {
          title: "Erik Wilkes Jr.",
          username: "@wilkesjr",
          badge: Icon.Badge,
          avatar: Img.PostAvatar1,
          photo: "",
          postDetails: "They sure do have a great collection. 💯",
          time: "11:12 PM · Sep 1, 2022",
          like: true,
        },
        {
          title: "Clarissa Kearney.",
          username: "@clarissaboo",
          badge: Icon.Badge,
          avatar: Img.PostAvatar2,
          photo: Img.post,
          postDetails: "They sure do have a great collection. 💯",
          time: "11:12 PM · Sep 1, 2022",
          like: false,
        },
        {
          title: "Erik Wilkes Jr.",
          username: "@wilkesjr",
          badge: Icon.Badge,
          avatar: Img.PostAvatar3,
          photo: "",
          postDetails: "They sure do have a great collection. 💯",
          time: "11:12 PM · Sep 1, 2022",
          like: false,
        },
        {
          title: "Erik Wilkes Jr.",
          username: "@wilkesjr",
          badge: Icon.Badge,
          avatar: Img.PostAvatar4,
          photo: "",
          postDetails: "They sure do have a great collection. 💯",
          time: "11:12 PM · Sep 1, 2022",
          like: false,
        },
        {
          title: "Erik Wilkes Jr.",
          username: "@wilkesjr",
          badge: Icon.Badge,
          avatar: Img.PostAvatar5,
          photo: "",
          postDetails: "They sure do have a great collection. 💯",
          time: "11:12 PM · Sep 1, 2022",
          like: false,
        },
        {
          title: "Erik Wilkes Jr.",
          username: "@wilkesjr",
          badge: Icon.Badge,
          avatar: Img.PostAvatar6,
          photo: "",
          postDetails: "They sure do have a great collection. 💯",
          time: "11:12 PM · Sep 1, 2022",
          like: false,
        },
      ];
    return (
        <VStack>
       <Stack pe="20px" height="620px" overflowY="auto" className="announcements-scroll-off">
          {AnnouncementsData.map((item) => (
            <Stack
              w={"100%"}
              mx="auto"
            >
              <Box
                w="100%"
                bg="#F5F5FF"
                borderRadius="26px"
                p="20px 30px"
                my="20px"
              >
                {/* topbar */}
                <Stack flexWrap="wrap" alignItems="center" w="100%">
                  <Stack
                    flexDir="row"
                    justifyContent="space-between"
                    alignItems="center"
                    w="100%"
                  >
                    <Box display="flex" alignItems="center" w="100%">
                      <Image src={item.avatar} h="43px" w="43px" mr="10px" />
                      <Box>
                        <Text
                          fontFamily="'Roboto',sans-serif"
                          fontSize="20px"
                          fontWeight="600"
                        >
                          {item.title}
                          <Badge variant="subtle">
                            {" "}
                            <Image src={item.badge} />
                          </Badge>
                        </Text>
                        <Text
                          fontFamily="'Roboto',sans-serif"
                          fontSize="16px"
                          fontWeight="400"
                        >
                          {item.username}
                        </Text>
                      </Box>
                    </Box>
                  </Stack>
                  <Stack flexDir="row" alignItems="center" w="100%">
                    <Box w="100%">
                      <Text
                        fontFamily="'Roboto',sans-serif"
                        fontSize="16px"
                        fontWeight="400"
                      >
                        {item.postDetails}
                      </Text>
                      <Box pt="10px" display="flex" alignItems="center" justifyContent="space-between">
                      <Button
                      bg="transparent"
                        fontFamily="'Roboto',sans-serif"
                        fontSize="16px"
                        fontWeight="400"
                        px="0"
                        _hover={{
                            bg:"transparent"
                        }}
                      >
                       See more..
                      </Button>
                      <Text
                        fontFamily="'Roboto',sans-serif"
                        fontSize="16px"
                        fontWeight="400"
                      >
                        {item.time}
                      </Text>
                      </Box>

                    </Box>
                  </Stack>
                </Stack>
              </Box>
            </Stack>
          ))}
        </Stack>
        </VStack>
    );
};

export default AnnouncementsRight;